import React from 'react';
import PropTypes from 'prop-types';
import Typography from 'components/typography';
import Button from '../../button';

const NEXT_LOGIN_STEPS = [
  {
    title: 'Correo y contraseña',
    desc: 'Ingresa tus datos como siempre.',
  },
  {
    title: 'Abre tu app de autenticación',
    desc: 'Google Authenticator, Authy o la que registraste.',
  },
  {
    title: 'Ingresa el código de 6 dígitos',
    desc: 'El que muestra la app para tu cuenta.',
  },
];

const StepThree = ({ onFinish }) => (
  <>
    <div className="step-three__check">
      <div className="check-circle">
        <div className="check-icon" />
      </div>
    </div>
    <Typography type="superTitle-italic" text="¡Verificación activada!" className="setup2fa__title" />
    <br />
    <Typography
      type="paragraph"
      text="Tu cuenta quedó registrada con verificación en dos pasos. La próxima vez que ingreses deberás seguir estos pasos:"
    />
    <br />
    <div className="step-three__steps">
      {NEXT_LOGIN_STEPS.map((s, i) => (
        <div key={s.title} className="step-row">
          <div className="step-circle">{i + 1}</div>
          <div>
            <Typography
              type="paragraph"
              text={s.title}
              className="step-text__title"
            />
            <Typography
              type="paragraph"
              text={s.desc}
              className="step-text__desc"
            />
          </div>
        </div>
      ))}
    </div>
    <div className="setup2fa__cta">
      <Button text="Entendido, finalizar" type="primary" onClick={onFinish} />
    </div>
  </>
);

StepThree.propTypes = {
  onFinish: PropTypes.func.isRequired,
};

export default StepThree;
